import React from "react"

import { withStyles } from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import TextField from '@material-ui/core/TextField'
import { I18n } from 'react-redux-i18n'

const styles = theme => ({
  container: {
    marginTop: theme.spacing.unit,
    marginBottom: theme.spacing.unit,
  },
  input:{
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: 'calc(100% - ' + theme.spacing.unit*2 + 'px)',
  },
});

class Subject extends React.Component {
  render() {
    const { classes } = this.props

    let error = false
    let errorMessage = ''

    // if(this.props.newAppointment.error != null ){
    //   if(this.props.newAppointment.error.errors.subject != null){
    //     error = true
    //     errorMessage = this.props.newAppointment.error.errors.subject[0]
    //   }
    // }

    return (
      <Grid container className={classes.container}>
        <Grid item xs={12}>
          <TextField
            error={error}
            onChange={this.props.handleSubjectChange}
            value={this.props.newAppointment.subject}
            label={error ? errorMessage : I18n.t('editAppointment.name_event')}
            className={classes.input}
            margin="normal"
          />
        </Grid>
      </Grid>
    )
  }
}

export default withStyles(styles)(Subject)



// WEBPACK FOOTER //
// ./src/js/components/pages/newAppointment/Subject.js